import { instances } from '@/services/http';
import type {
  SignUpProspectPostReferredVerifyCodeRequestType,
  SignUpProspectPostReferredVerifyCodeResponseType,
} from '@magma-app/magma-types/sign-up-prospect';
import { useMutation } from '@tanstack/vue-query';

export const useVerifyCode = () => {
  return useMutation({
    mutationFn: async (
      payload: SignUpProspectPostReferredVerifyCodeRequestType
    ) => {
      const response = await instances.main.post(
        '/sign-up-prospect/referred/phone/verify-code',
        payload
      );
      return response.data as SignUpProspectPostReferredVerifyCodeResponseType;
    },
  });
};
